import { IKeyboardShortcutHandlerProvider, IKeyboardShortcutHandler } from '@/components/chat/_domain/modules/keyboard-shortcut-service/keyboard-shortcut-service-interface';
import { keyboardShortcutHandlerTypes } from '@/components/chat/_domain/modules/keyboard-shortcut-service/handlers';
import { injectable } from 'inversify';

@injectable()
class KeyboardShortcutHandlerProvider implements IKeyboardShortcutHandlerProvider {
  private readonly keyboardShortcutHandlers: IKeyboardShortcutHandler[] = [];

  constructor() {
    this.initialiseKeyboardShortcutHandlers();
  }

  public getAllHandlers(): IKeyboardShortcutHandler[] {
    return this.keyboardShortcutHandlers;
  }

  private initialiseKeyboardShortcutHandlers() {
    Object.keys(keyboardShortcutHandlerTypes).forEach(this.initialiseKeyboardShortcutHandler, this);
  }

  private initialiseKeyboardShortcutHandler(keyboardShortcutHandlerTypeName: string): void {
    const keyboardShortcutHandlerType = keyboardShortcutHandlerTypes[keyboardShortcutHandlerTypeName];
    const keyboardShortcutHandlerInstance = this.getKeyboardShortcutHandlerInstance(keyboardShortcutHandlerType);
    this.addKeyboardShortcutHandler(keyboardShortcutHandlerInstance);
  }

  private getKeyboardShortcutHandlerInstance(keyboardShortcutHandlerType: new() => IKeyboardShortcutHandler): IKeyboardShortcutHandler {
    return new keyboardShortcutHandlerType();
  }

  private addKeyboardShortcutHandler(keyboardShortcutHandler: IKeyboardShortcutHandler): void {
    this.keyboardShortcutHandlers.push(keyboardShortcutHandler);
  }
}

export { KeyboardShortcutHandlerProvider };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/keyboard-shortcut-service/keyboard-shortcut-handler-provider.ts